import { render, staticRenderFns } from "./ErrorNotice.vue?vue&type=template&id=e6aa36f6&scoped=true&"
import script from "./ErrorNotice.vue?vue&type=script&lang=js&"
export * from "./ErrorNotice.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotice.vue?vue&type=style&index=0&id=e6aa36f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aa36f6",
  null
  
)

export default component.exports